import React, { useState } from "react";
import WplMultipleButtonInput from "../../components/wpl-multiple-button-input/wplMultipleButtonInput";
import ArrowAnimation from "../../components/arrow-animation/ArrowAnimation";

export default function CustomTriggerForm({
    triggerData,
    onTriggerChange,
    turbineModels = [],
    className = ""
}) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onTriggerChange({
            ...triggerData,
            [name]: value,
        });
    };

    const handleMultipleButtonChange = (selectedOption) => {
        onTriggerChange({
            ...triggerData,
            is_subsequent: selectedOption === "Subsequent stroke",
        });
    };

    const handleTurbineModelToggle = (model) => {
        const newSelection = triggerData.turbine_models.includes(model)
            ? triggerData.turbine_models.filter((m) => m !== model)
            : [...triggerData.turbine_models, model];

        onTriggerChange({
            ...triggerData,
            turbine_models: newSelection,
        });
    };

    const formatMinProbability = (value) => {
        if (value === null || value === undefined || value === "") return "";
        if (value > 1) return value.toString();
        return (parseFloat(value) * 100).toString();
    };

    return (
        <div className={className}>
            <span className="inline-input">
                <WplMultipleButtonInput
                    options={["First stroke", "Subsequent stroke"]}
                    value={triggerData.is_subsequent ? "Subsequent stroke" : "First stroke"}
                    onChanged={handleMultipleButtonChange}
                    className="small-font"
                />
            </span>
            <span>
                <p className="trigger-key">Min Probability</p>
                <div className="trigger-span">
                    <input
                        className="trigger-input"
                        type="number"
                        name="min_probability"
                        min="0"
                        max="100"
                        step="1"
                        value={formatMinProbability(triggerData.min_probability)}
                        onChange={handleInputChange}
                    />
                    <p>%</p>
                </div>
            </span>
            <span>
                <p className="trigger-key">Max distance</p>
                <div className="trigger-span">
                    <input
                        className="trigger-input"
                        type="number"
                        name="max_distance_km"
                        value={triggerData.max_distance_km || ""}
                        onChange={handleInputChange}
                        min="0"
                    />
                    <p>m</p>
                </div>
            </span>
            <span>
                <p className="trigger-key">Peak Current</p>
                <div className="trigger-span"  style={{ marginBottom: '1rem' }}>
                    <input
                        className="trigger-input"
                        type="number"
                        name="min_peak_current"
                        value={triggerData.min_peak_current || ""}
                        onChange={handleInputChange}
                    />
                    <p className="trigger-key">min kA</p>
                </div>
            </span>
            <span>
                <div className="trigger-span"  style={{ marginBottom: '1rem' }}>
                    <input
                        className="trigger-input"
                        type="number"
                        name="max_peak_current"
                        value={triggerData.max_peak_current || ""}
                        onChange={handleInputChange}
                    />
                    <p className="trigger-key">max kA</p>
                </div>
            </span>
            <span>
                <div className="trigger-span" style={{ position: 'relative' }}>
                    <div
                        className="dropdown-header"
                        onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                        <p className="trigger-key">Turbine model</p>
                        <ArrowAnimation showMore={dropdownOpen} size={1} />
                    </div>

                    {dropdownOpen && (
                        <div className="dropdown-options">
                            {turbineModels
                                .filter((model) => model !== null && model !== undefined)
                                .map((model) => (
                                    <div
                                        key={model}
                                        className="dropdown-option"
                                        onClick={() => handleTurbineModelToggle(model)}
                                    >
                                        <span>{model}</span>
                                        <input
                                            type="checkbox"
                                            checked={triggerData.turbine_models.includes(model)}
                                        />
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </span>
        </div>
    );
};
